/* INNAYA 2026 storefront interactions (no dependencies) */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  doc.classList.add('inx-js');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '$') + n;
  }

  /* ---------------- reveal on scroll ---------------- */
  function initReveal() {
    var els = $all('[data-inx-reveal]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('inx-pre'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.top > vh * 0.92) {
        el.classList.add('inx-pre');
        el.style.transitionDelay = (Number(el.getAttribute('data-inx-reveal')) || 0) + 'ms';
        io.observe(el);
      }
    });
  }

  /* ---------------- hologram fan POV simulation ---------------- */
  function HoloFan(canvas, opts) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.blades = opts.blades || 4;
    this.leds = opts.leds || 60;
    this.scene = opts.scene || 'logo';
    this.word = opts.word || 'INNAYA';
    this.angle = 0;
    this.t = 0;
    this.running = false;
    this.off = document.createElement('canvas');
    this.octx = this.off.getContext('2d', { willReadFrequently: true });
    this.px = null;
    this.resize();
  }
  HoloFan.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = this.c.clientWidth || 500;
    this.size = Math.round(w * dpr);
    this.c.width = this.size; this.c.height = this.size;
    this.R = this.size * 0.46;
    this.cx = this.size / 2; this.cy = this.size / 2;
    this.off.width = this.size; this.off.height = this.size;
    this.dot = Math.max(1.6, this.size / 230);
    this.ctx.clearRect(0, 0, this.size, this.size);
  };
  HoloFan.prototype.drawScene = function () {
    var o = this.octx, s = this.size, cx = this.cx, cy = this.cy, R = this.R, t = this.t;
    o.clearRect(0, 0, s, s);
    o.fillStyle = '#000'; o.fillRect(0, 0, s, s);
    var hue = (t * 0.6) % 360;
    if (this.scene === 'logo') {
      var fs = R * 0.4;
      o.font = '700 ' + fs + 'px Unbounded, Arial Black, sans-serif';
      var tw = o.measureText(this.word).width;
      if (tw > R * 1.5) { fs = fs * R * 1.5 / tw; o.font = '700 ' + fs + 'px Unbounded, Arial Black, sans-serif'; }
      o.textAlign = 'center'; o.textBaseline = 'middle';
      var g = o.createLinearGradient(cx - R, cy, cx + R, cy);
      g.addColorStop(0, 'hsl(' + ((hue + 180) % 360) + ',95%,62%)');
      g.addColorStop(0.5, 'hsl(' + ((hue + 250) % 360) + ',95%,70%)');
      g.addColorStop(1, 'hsl(' + ((hue + 30) % 360) + ',100%,62%)');
      o.fillStyle = g;
      var sc = 1 + Math.sin(t * 0.03) * 0.04;
      o.save(); o.translate(cx, cy); o.scale(sc, sc);
      o.fillText(this.word, 0, 0);
      o.restore();
      o.strokeStyle = 'hsl(' + ((hue + 200) % 360) + ',90%,60%)';
      o.lineWidth = R * 0.035;
      o.beginPath(); o.arc(cx, cy, R * 0.82, t * 0.02, t * 0.02 + Math.PI * 1.35); o.stroke();
      o.beginPath(); o.arc(cx, cy, R * 0.7, -t * 0.03, -t * 0.03 + Math.PI * 0.7); o.stroke();
    } else if (this.scene === 'globe') {
      var rot = t * 0.012, rr = R * 0.72;
      for (var lat = -75; lat <= 75; lat += 15) {
        for (var lon = 0; lon < 360; lon += 10) {
          var la = lat * Math.PI / 180, lo = lon * Math.PI / 180 + rot;
          var x = Math.cos(la) * Math.sin(lo), y = Math.sin(la), z = Math.cos(la) * Math.cos(lo);
          if (z < -0.1) continue;
          var b = 45 + z * 40;
          o.fillStyle = 'hsl(' + ((190 + lat + hue * 0.2) % 360) + ',90%,' + b + '%)';
          o.beginPath(); o.arc(cx + x * rr, cy - y * rr, R * 0.035, 0, Math.PI * 2); o.fill();
        }
      }
      o.strokeStyle = 'rgba(255,181,71,.9)'; o.lineWidth = R * 0.03;
      o.beginPath(); o.ellipse(cx, cy, R * 0.9, R * 0.22, -0.35, 0, Math.PI * 2); o.stroke();
    } else {
      var pulse = 1 + Math.sin(t * 0.08) * 0.06;
      o.textAlign = 'center'; o.textBaseline = 'middle';
      o.save(); o.translate(cx, cy); o.scale(pulse, pulse);
      o.font = '800 ' + (R * 0.6) + 'px Unbounded, Arial Black, sans-serif';
      o.fillStyle = 'hsl(' + ((hue + 20) % 360) + ',100%,60%)';
      o.fillText('-50%', 0, -R * 0.05);
      o.font = '600 ' + (R * 0.16) + 'px Unbounded, Arial, sans-serif';
      o.fillStyle = '#ffffff';
      o.fillText('TODAY ONLY', 0, R * 0.42);
      o.restore();
      for (var k = 0; k < 14; k++) {
        var a = k / 14 * Math.PI * 2 + t * 0.02;
        o.fillStyle = 'hsl(' + ((k * 25 + hue) % 360) + ',100%,65%)';
        o.beginPath(); o.arc(cx + Math.cos(a) * R * 0.88, cy + Math.sin(a) * R * 0.88, R * 0.04, 0, Math.PI * 2); o.fill();
      }
    }
    this.px = o.getImageData(0, 0, s, s).data;
  };
  HoloFan.prototype.frame = function () {
    var ctx = this.ctx, s = this.size;
    if (this.t % 2 === 0 || !this.px) this.drawScene();
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,0.34)';
    ctx.fillRect(0, 0, s, s);
    ctx.globalCompositeOperation = 'source-over';
    var px = this.px, R = this.R, cx = this.cx, cy = this.cy, L = this.leds, d = this.dot;
    var sub = this.sub || 20, step = (Math.PI * 2 / this.blades) / sub;
    for (var k = 0; k < sub; k++) {
      var base = this.angle + k * step;
      for (var b = 0; b < this.blades; b++) {
        var th = base + b * (Math.PI * 2 / this.blades);
        var cs = Math.cos(th), sn = Math.sin(th);
        for (var i = 3; i < L; i++) {
          var r = (i + 0.5) / L * R;
          var x = cx + r * cs, y = cy + r * sn;
          var idx = ((y | 0) * s + (x | 0)) * 4;
          var red = px[idx], gr = px[idx + 1], bl = px[idx + 2];
          if (red + gr + bl < 90) continue;
          ctx.fillStyle = 'rgb(' + red + ',' + gr + ',' + bl + ')';
          ctx.fillRect(x - d / 2, y - d / 2, d, d);
        }
      }
    }
    /* the physical blades: faint arms at the current angle */
    ctx.strokeStyle = 'rgba(150,170,200,0.10)';
    ctx.lineWidth = Math.max(2, d * 1.4);
    for (var bb = 0; bb < this.blades; bb++) {
      var tb = this.angle + bb * (Math.PI * 2 / this.blades);
      ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + R * Math.cos(tb), cy + R * Math.sin(tb)); ctx.stroke();
    }
    ctx.fillStyle = '#10141c';
    ctx.beginPath(); ctx.arc(cx, cy, R * 0.05, 0, Math.PI * 2); ctx.fill();
    this.angle += 0.37;
    this.t++;
  };
  HoloFan.prototype.still = function () {
    this.drawScene();
    var ctx = this.ctx, s = this.size;
    ctx.clearRect(0, 0, s, s);
    for (var k = 0; k < 90; k++) { this.frame(); }
  };
  HoloFan.prototype.start = function () {
    if (this.running) return;
    this.running = true;
    var self = this;
    (function loop() { if (!self.running) return; self.frame(); self.raf = requestAnimationFrame(loop); })();
  };
  HoloFan.prototype.stop = function () { this.running = false; if (this.raf) cancelAnimationFrame(this.raf); };

  function initHero() {
    $all('[data-inx-hero]').forEach(function (hero) {
      var canvas = $('canvas', hero);
      if (!canvas || !canvas.getContext) return;
      var fan = new HoloFan(canvas, {
        blades: Number(canvas.getAttribute('data-blades')) || 4,
        leds: Number(canvas.getAttribute('data-leds')) || 60,
        word: canvas.getAttribute('data-word') || 'INNAYA'
      });
      fan.sub = window.innerWidth < 700 ? 12 : 20;
      var go = function () { if (reduce) fan.still(); else fan.start(); };
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(go); } else { go(); }
      if ('IntersectionObserver' in window && !reduce) {
        new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) fan.start(); else fan.stop(); }); }).observe(canvas);
      }
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fan.resize(); if (reduce) fan.still(); }, 150); });
      $all('[data-scene]', hero).forEach(function (btn) {
        btn.addEventListener('click', function () {
          fan.scene = btn.getAttribute('data-scene');
          fan.px = null;
          $all('[data-scene]', hero).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (reduce) fan.still();
        });
      });
      var stage = $('.inx-hero__stage', hero);
      if (stage && !reduce && window.matchMedia('(pointer:fine)').matches) {
        hero.addEventListener('pointermove', function (e) {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          stage.style.transform = 'perspective(1200px) rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)';
        });
        hero.addEventListener('pointerleave', function () { stage.style.transform = ''; });
      }
    });
  }

  /* ---------------- size finder ---------------- */
  function initFinder() {
    $all('[data-inx-finder]').forEach(function (root) {
      var dataEl = $('script[type="application/json"]', root);
      if (!dataEl) return;
      var items;
      try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!items.length) return;
      var space = 'all';
      var range = $('input[type=range]', root);
      var out = $('[data-dist]', root);
      var res = $('[data-result]', root);
      var fmt = root.getAttribute('data-currency') || '$';
      function render() {
        var d = Number(range.value);
        out.textContent = d.toFixed(1);
        var pool = items.filter(function (it) { return space === 'all' || (it.spaces || '').indexOf(space) > -1; });
        if (!pool.length) pool = items;
        pool = pool.map(function (it) {
          var gap = d < it.min ? it.min - d : (d > it.max ? d - it.max : 0);
          return { it: it, gap: gap };
        }).sort(function (a, b) { return a.gap - b.gap || a.it.min - b.it.min; });
        var best = pool[0].it;
        $('[data-r-img]', res).src = best.img;
        $('[data-r-img]', res).alt = best.title;
        $('[data-r-name]', res).textContent = best.title;
        $('[data-r-why]', res).textContent = best.why;
        $('[data-r-spec]', res).textContent = best.spec;
        $('[data-r-price]', res).textContent = best.price ? money(best.price, fmt) : '';
        $('[data-r-link]', res).href = best.url;
        $('[data-r-match]', res).textContent = pool[0].gap === 0 ? 'Best match for ' + d.toFixed(1) + ' m' : 'Closest match';
        var alts = $('[data-r-alts]', res);
        alts.innerHTML = '';
        pool.slice(1, 3).forEach(function (p) {
          var a = document.createElement('a');
          a.href = p.it.url; a.textContent = 'Also consider: ' + p.it.short;
          alts.appendChild(a);
        });
      }
      $all('[data-space]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          space = btn.getAttribute('data-space');
          $all('[data-space]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var preset = btn.getAttribute('data-preset');
          if (preset) range.value = preset;
          render();
        });
      });
      range.addEventListener('input', render);
      render();
    });
  }

  /* ---------------- lineup filters + tilt ---------------- */
  function initLineup() {
    $all('[data-inx-lineup]').forEach(function (root) {
      var cards = $all('.inx-card', root);
      $all('[data-filter]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var f = btn.getAttribute('data-filter');
          $all('[data-filter]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          cards.forEach(function (c) { c.hidden = !(f === 'all' || (' ' + c.getAttribute('data-cats') + ' ').indexOf(' ' + f + ' ') > -1); });
        });
      });
    });
    if (reduce || !window.matchMedia('(pointer:fine)').matches) return;
    $all('.inx-card').forEach(function (card) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.transform = 'perspective(900px) rotateY(' + ((x - 0.5) * 8).toFixed(2) + 'deg) rotateX(' + ((0.5 - y) * 8).toFixed(2) + 'deg) translateY(-4px)';
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------------- wall builder ---------------- */
  function initWall() {
    $all('[data-inx-wall]').forEach(function (root) {
      var rows = 3, cols = 3, size = 65;
      var grid = $('.inx-wall__grid', root);
      var fmt = root.getAttribute('data-currency') || '$';
      var prices = {};
      $all('[data-size]', root).forEach(function (b) { prices[b.getAttribute('data-size')] = Number(b.getAttribute('data-price')) || 0; });
      var router = Number(root.getAttribute('data-router')) || 0;
      function paint() {
        grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0,1fr))';
        var n = rows * cols;
        grid.innerHTML = '';
        for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'inx-wall__cell'; c.style.animationDelay = (i * 40) + 'ms'; grid.appendChild(c); }
        $('[data-rows]', root).textContent = rows;
        $('[data-cols]', root).textContent = cols;
        var wcm = cols * size, hcm = rows * size;
        $('[data-w-size]', root).textContent = wcm + ' × ' + hcm + ' cm';
        $('[data-w-in]', root).textContent = Math.round(wcm / 2.54) + ' × ' + Math.round(hcm / 2.54) + ' in';
        $('[data-w-fans]', root).textContent = n + (n === 1 ? ' fan' : ' fans');
        var est = n * (prices[String(size)] || 0) + (n > 1 ? router : 0);
        $('[data-w-est]', root).textContent = est ? 'From ' + money(est, fmt) : 'Quote';
      }
      $all('[data-step]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var k = b.getAttribute('data-step');
          if (k === 'r+') rows = Math.min(4, rows + 1);
          if (k === 'r-') rows = Math.max(1, rows - 1);
          if (k === 'c+') cols = Math.min(4, cols + 1);
          if (k === 'c-') cols = Math.max(1, cols - 1);
          paint();
        });
      });
      $all('[data-size]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          size = Number(b.getAttribute('data-size'));
          $all('[data-size]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          paint();
        });
      });
      paint();
    });
  }

  /* ---------------- use-case tabs ---------------- */
  function initUses() {
    $all('[data-inx-uses]').forEach(function (root) {
      var tabs = $all('[role=tab]', root);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); x.tabIndex = x === t ? 0 : -1; });
          $all('[role=tabpanel]', root).forEach(function (p) { p.hidden = p.id !== t.getAttribute('aria-controls'); });
        });
        t.addEventListener('keydown', function (e) {
          var j = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? i - 1 : null;
          if (j === null) return;
          e.preventDefault();
          var n = tabs[(j + tabs.length) % tabs.length]; n.focus(); n.click();
        });
      });
    });
  }

  /* ---------------- gobo throw calculator ---------------- */
  function initGobo() {
    $all('[data-inx-gobo]').forEach(function (root) {
      var range = $('input[type=range]', root);
      var floor = $('.inx-gobo__floor', root);
      var angle = Number(root.getAttribute('data-angle')) || 20;
      function upd() {
        var d = Number(range.value);
        var dia = 2 * d * Math.tan(angle / 2 * Math.PI / 180);
        $('[data-g-dist]', root).textContent = d.toFixed(1) + ' m / ' + (d * 3.281).toFixed(1) + ' ft';
        $('[data-g-dia]', root).textContent = dia.toFixed(2) + ' m / ' + (dia * 3.281).toFixed(1) + ' ft';
        var px = Math.max(90, Math.min(floor.clientWidth * 0.95, 60 + dia * 110));
        floor.style.setProperty('--spotw', px.toFixed(0) + 'px');
        floor.style.setProperty('--beamw', (px * 0.75).toFixed(0) + 'px');
      }
      range.addEventListener('input', upd);
      window.addEventListener('resize', upd);
      upd();
    });
  }

  function boot() {
    initReveal(); initHero(); initFinder(); initLineup(); initWall(); initUses(); initGobo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { initHero(); initFinder(); initLineup(); initWall(); initUses(); initGobo(); });
})();


/* ============================================================
   INNAYA 2026 — APPENDED FIX LAYER (added 2026-10-21)
   1. Strips leaked Liquid errors from PageFly sections
   2. Auto-fixes unreadable button text (contrast)
   3. Hover image swap on product cards (2nd product shot)
   4. Makes the Size Finder result card fully clickable
   5. Adds the glow plate behind product imagery
   ============================================================ */
;(function () {
  'use strict';

  var LIQUID_ERR = /Liquid error \(sections\/[^)]*\)\s*:/i;

  /* 1. PageFly renders >20 ProductBoxes on the fan pages. Shopify only
        resolves 20 all_products lookups per page, so the overflow boxes
        print "product form must be given a product" into the DOM. */
  function stripLiquidErrors() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node, doomed = [];
    while ((node = walker.nextNode())) {
      if (LIQUID_ERR.test(node.nodeValue)) doomed.push(node);
    }
    doomed.forEach(function (n) {
      var host = n.parentElement;
      n.nodeValue = '';
      if (host && !host.children.length) host.classList.add('inx-liquid-error');
    });
  }

  /* 2. Any button whose label falls under ~3.2:1 against its own
        background gets flipped to ink or paper, whichever wins. */
  function parseRGB(str) {
    var m = String(str).match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    if (p.length > 3 && p[3] === 0) return null;
    return { r: p[0], g: p[1], b: p[2] };
  }
  function luminance(c) {
    var a = [c.r, c.g, c.b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  function ratio(a, b) {
    var l1 = luminance(a), l2 = luminance(b);
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
  }
  function effectiveBg(el) {
    var n = el;
    while (n && n !== document.documentElement) {
      var bg = parseRGB(getComputedStyle(n).backgroundColor);
      if (bg) return bg;
      n = n.parentElement;
    }
    return { r: 5, g: 6, b: 10 };
  }
  function fixContrast() {
    var sel = 'button, a.button, .button, .pf-button-1,' +
              '[data-pf-type="Button"],[data-pf-type="Button2"],' +
              '[data-pf-type="ProductATC2"],[data-pf-type="Form2.Button2"]';
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.dataset.inxContrast || !el.offsetParent) return;
      var cs = getComputedStyle(el);
      var fg = parseRGB(cs.color);
      var bg = effectiveBg(el);
      if (!fg || !bg) return;
      if (ratio(fg, bg) >= 3.2) return;
      var ink = { r: 4, g: 19, b: 26 };
      var paper = { r: 245, g: 248, b: 255 };
      el.dataset.inxContrast = ratio(ink, bg) >= ratio(paper, bg) ? 'light' : 'dark';
    });
  }

  /* 3. Hover image swap */
  var imgCache = {};
  function secondImage(handle) {
    if (imgCache[handle]) return imgCache[handle];
    imgCache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.images || p.images.length < 2) return null;
        return p.images[1];
      })
      .catch(function () { return null; });
    return imgCache[handle];
  }
  function wireHoverSwap() {
    var cards = document.querySelectorAll(
      '.inx-card[href*="/products/"], .inx-xcard[href*="/products/"],' +
      '.card-wrapper a[href*="/products/"]'
    );
    cards.forEach(function (card) {
      var anchor = card.tagName === 'A' ? card : card.closest('a');
      if (!anchor || anchor.dataset.inxSwap) return;
      anchor.dataset.inxSwap = '1';
      var media = anchor.querySelector('.inx-card__media, .inx-xcard__media, .card__media, .media')
                || anchor.closest('.card-wrapper') && anchor.closest('.card-wrapper').querySelector('.card__media');
      if (!media) return;
      media.classList.add('inx-glow');
      var handle = (anchor.getAttribute('href') || '').split('/products/')[1];
      if (!handle) return;
      handle = handle.split('?')[0].split('#')[0].split('/')[0];
      var armed = false;
      var arm = function () {
        if (armed) return;
        armed = true;
        secondImage(handle).then(function (src) {
          if (!src || media.querySelector('.inx-alt-img')) return;
          var img = new Image();
          img.className = 'inx-alt-img';
          img.loading = 'lazy';
          img.alt = '';
          img.src = src;
          media.appendChild(img);
        });
      };
      anchor.addEventListener('mouseenter', arm, { once: true });
      anchor.addEventListener('focusin', arm, { once: true });
    });
  }

  /* 4. Size Finder result card becomes one big target */
  function wireFinder() {
    var finder = document.querySelector('[id$="__finder"]');
    if (!finder) return;
    var cta = Array.prototype.slice
      .call(finder.querySelectorAll('a[href*="/products/"]'))
      .filter(function (a) { return /view this fan/i.test(a.innerText || ''); })[0];
    if (!cta) return;
    var card = cta.closest('[class*="result"]') || cta.parentElement.parentElement;
    if (!card || card.dataset.inxHit) return;
    card.dataset.inxHit = '1';
    card.classList.add('inx-finder__result');
    var hit = document.createElement('a');
    hit.className = 'inx-result-hit';
    hit.setAttribute('aria-label', 'View the recommended fan');
    card.appendChild(hit);
    var sync = function () { hit.setAttribute('href', cta.getAttribute('href')); };
    sync();
    new MutationObserver(sync).observe(cta, { attributes: true, attributeFilter: ['href'] });
  }

  /* 5. Glow plate on main product media */
  function wireGlow() {
    document.querySelectorAll('[data-pf-type="MediaMain"], .product__media-wrapper .product__media')
      .forEach(function (el) { el.classList.add('inx-glow'); });
  }

  function run() {
    try { stripLiquidErrors(); } catch (e) {}
    try { fixContrast(); } catch (e) {}
    try { wireHoverSwap(); } catch (e) {}
    try { wireFinder(); } catch (e) {}
    try { wireGlow(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', function () { setTimeout(run, 400); });

  var mo = new MutationObserver(function (muts) {
    if (muts.some(function (m) { return m.addedNodes.length; })) {
      clearTimeout(window.__inxT);
      window.__inxT = setTimeout(run, 250);
    }
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   INNAYA 2026 — MEGA MENU (added 2026-10-21)
   Reads the live Shopify navigation and expands each top-level
   dropdown into a graphical panel. Collection and product links
   become image columns pulled from the storefront; page links
   are grouped into a tidy link column. Edit Navigation in the
   Shopify admin and this panel follows automatically.
   Desktop only (>=990px); the mobile drawer is untouched.
   ============================================================ */
;(function () {
  'use strict';

  var DESKTOP = '(min-width:990px)';
  var cache = {};

  function money(v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : '$' + n.toFixed(2).replace(/\.00$/, '');
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fetchJSON(url) {
    if (cache[url]) return cache[url];
    cache[url] = fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[url];
  }
  function pathOf(href) {
    if (!href) return '';
    try { return new URL(href, location.origin).pathname; } catch (e) { return href; }
  }

  var PROMOS = {
    'default': {
      h: 'Not sure which size?',
      p: 'The Size Finder matches a fan to your room and viewing distance in about ten seconds.',
      cta: 'Find my fan', href: '/'
    },
    'support': {
      h: 'Talk to a human',
      p: 'Setup questions, warranty or a custom build — we answer every message ourselves.',
      cta: 'Contact us', href: '/pages/contact'
    }
  };
  function promoFor(label) {
    return PROMOS[(label || '').trim().toLowerCase()] || PROMOS['default'];
  }

  function itemHTML(href, name, meta, img) {
    var thumb = img
      ? '<span class="inx-mega__thumb"><img src="' + img + '" alt="" loading="lazy"></span>'
      : '<span class="inx-mega__thumb"></span>';
    return '<a class="inx-mega__item" href="' + href + '">' + thumb +
      '<span class="inx-mega__txt"><span class="inx-mega__name">' + name + '</span>' +
      (meta ? '<span class="inx-mega__meta">' + meta + '</span>' : '') +
      '</span></a>';
  }

  function fillColumn(col, child) {
    var body = col.querySelector('.inx-mega__body');
    var p = pathOf(child.h);

    if (/^\/collections\//.test(p)) {
      var handle = p.split('/collections/')[1].split('/')[0];
      return fetchJSON('/collections/' + handle + '/products.json?limit=4')
        .then(function (d) {
          var list = (d && d.products) || [];
          var html = list.map(function (pr) {
            var img = (pr.images && pr.images[0] && pr.images[0].src) || '';
            var price = pr.variants && pr.variants[0] && money(pr.variants[0].price);
            return itemHTML('/products/' + pr.handle, esc(pr.title), price, img);
          }).join('');
          body.innerHTML = html +
            '<a class="inx-mega__all" href="' + child.h + '">View all &rarr;</a>';
        });
    }
    if (/^\/products\//.test(p)) {
      var ph = p.split('/products/')[1].split('/')[0];
      return fetchJSON('/products/' + ph + '.js').then(function (pr) {
        body.innerHTML = itemHTML(child.h, esc(pr ? pr.title : child.t),
          pr ? money(pr.price / 100) : '', pr && pr.featured_image);
      });
    }
    body.innerHTML = itemHTML(child.h, esc(child.t), '', '');
    return Promise.resolve();
  }

  function build(det, label) {
    var submenu = det.querySelector('.header__submenu');
    if (!submenu) return;

    /* textContent, not innerText: a closed <details> is unrendered,
       so innerText comes back empty at build time. */
    var children = Array.prototype.slice
      .call(submenu.querySelectorAll(':scope > li'))
      .map(function (li) {
        var a = li.querySelector(':scope > a') ||
                li.querySelector(':scope > details > summary');
        if (!a) return null;
        var href = a.getAttribute('href');
        if (!href) { var f = li.querySelector('a[href]'); href = f && f.getAttribute('href'); }
        return { t: (a.textContent || '').trim(), h: href || '#' };
      })
      .filter(function (c) { return c && c.t; });

    if (!children.length) return;
    det.dataset.inxMega = '1';

    var rich = [], plain = [];
    children.forEach(function (c) {
      var p = pathOf(c.h);
      (/^\/(collections|products)\//.test(p) ? rich : plain).push(c);
    });

    var chunks = [];
    for (var i = 0; i < plain.length; i += 5) chunks.push(plain.slice(i, i + 5));

    var promo = promoFor(label);
    var panel = document.createElement('div');
    panel.className = 'inx-mega';

    var richHTML = rich.map(function (c) {
      return '<div class="inx-mega__col">' +
        '<a class="inx-mega__kicker" href="' + c.h + '">' + esc(c.t) + '</a>' +
        '<div class="inx-mega__body"><div class="inx-mega__skel"></div>' +
        '<div class="inx-mega__skel"></div></div></div>';
    }).join('');

    var plainHTML = chunks.map(function (group, gi) {
      return '<div class="inx-mega__col inx-mega__col--links">' +
        '<span class="inx-mega__kicker">' +
          esc(gi === 0 ? (rich.length ? 'More' : label) : ' ') + '</span>' +
        '<div class="inx-mega__body">' +
        group.map(function (c) {
          return '<a class="inx-mega__link" href="' + c.h + '">' + esc(c.t) + '</a>';
        }).join('') + '</div></div>';
    }).join('');

    panel.innerHTML = '<div class="inx-mega__grid">' + richHTML + plainHTML +
      '<div class="inx-mega__promo">' +
        '<h4>' + esc(promo.h) + '</h4>' +
        '<p>' + esc(promo.p) + '</p>' +
        '<a class="inx-mega__cta" href="' + promo.href + '">' + esc(promo.cta) + '</a>' +
      '</div></div>';

    if (!rich.length) panel.classList.add('inx-mega--compact'); det.appendChild(panel);

    var loaded = false;
    var load = function () {
      if (loaded) return;
      loaded = true;
      var cols = panel.querySelectorAll('.inx-mega__col:not(.inx-mega__col--links)');
      rich.forEach(function (c, i) { if (cols[i]) fillColumn(cols[i], c); });
    };

    det.addEventListener('toggle', function () { if (det.open) load(); });

    var closeT;
    var li = det.closest('li') || det;
    li.addEventListener('mouseenter', function () {
      if (!window.matchMedia(DESKTOP).matches) return;
      clearTimeout(closeT);
      load();
      det.open = true;
    });
    li.addEventListener('mouseleave', function () {
      if (!window.matchMedia(DESKTOP).matches) return;
      closeT = setTimeout(function () { det.open = false; }, 190);
    });
  }

  /* Panel is viewport-centred, so it needs the header's bottom edge. */
  function syncTop() {
    var h = document.querySelector('header.header');
    if (!h) return;
    var b = Math.round(h.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--inx-hdr-bottom', b + 'px');
  }

  function init() {
    if (!window.matchMedia(DESKTOP).matches) return;
    var nav = document.querySelector('nav.header__inline-menu');
    if (!nav) return;
    syncTop();
    nav.querySelectorAll('details').forEach(function (det) {
      if (det.dataset.inxMega) return;
      var sum = det.querySelector('summary');
      var label = sum ? (sum.textContent || '').trim() : '';
      try { build(det, label); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  window.addEventListener('load', function () { setTimeout(init, 500); });
  window.addEventListener('scroll', syncTop, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(window.__inxMegaT);
    window.__inxMegaT = setTimeout(function () { init(); syncTop(); }, 250);
  });
})();


/* ============================================================
   INNAYA 2026 — POLICY / CONTENT PAGES (added 2026-10-21)
   Dawn's page template prints {{ page.title }} as an h1, and
   several pages repeat that title as the first heading of the
   rich-text body — so Warranty showed "Warranty" twice. Drop
   the repeat, tag the wrapper for styling, and reveal the
   blocks on scroll.
   ============================================================ */
;(function () {
  'use strict';

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function wirePolicy() {
    var title = document.querySelector('h1.main-page-title');
    if (!title) return;
    var wrap = title.parentElement;
    if (!wrap || wrap.dataset.inxPolicy) return;
    wrap.dataset.inxPolicy = '1';
    wrap.classList.add('inx-policy');

    var rte = wrap.querySelector('.rte');
    if (!rte) return;

    /* Drop a leading heading that only repeats the page title. */
    var first = rte.firstElementChild;
    while (first && !first.textContent.trim()) first = first.nextElementSibling;
    if (first && /^H[1-3]$/.test(first.tagName) &&
        norm(first.textContent) === norm(title.textContent)) {
      first.remove();
    }

    /* Reveal each block as it scrolls into view. */
    var blocks = Array.prototype.slice.call(rte.children);
    if (!blocks.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      blocks.forEach(function (b) { b.classList.add('inx-in'); });
      return;
    }

    blocks.forEach(function (b, i) {
      b.classList.add('inx-reveal');
      b.style.transitionDelay = Math.min(i * 40, 360) + 'ms';
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('inx-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    blocks.forEach(function (b) { io.observe(b); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wirePolicy);
  } else { wirePolicy(); }
  window.addEventListener('load', function () { setTimeout(wirePolicy, 300); });
})();


/* ============================================================
   INNAYA 2026 — SCROLL REVEAL FOR /pages/* (added 2026-10-21)
   Animates PageFly sections in as they enter the viewport.
   Scoped to content pages so product galleries, sliders and
   the cart are left alone. Anything already on screen at load
   is shown immediately, so the page never opens blank.
   ============================================================ */
;(function () {
  'use strict';

  function wireSections() {
    if (!/^\/pages\//.test(location.pathname)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    if (document.readyState !== 'complete') return; var sections = document.querySelectorAll('[data-pf-type="Section"]');
    if (!sections.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('inx-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.04 });

    sections.forEach(function (s) {
      if (s.dataset.inxSreveal) return;
      s.dataset.inxSreveal = '1';

      var r = s.getBoundingClientRect(); if (r.height < 20) return; var top = r.top;
      s.classList.add('inx-sreveal');

      /* Already in view on load — show it now, no flash of nothing. */
      if (top < window.innerHeight * 0.92) {
        s.classList.add('inx-in');
        return;
      }
      io.observe(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireSections);
  } else { wireSections(); }
  window.addEventListener('load', function () { setTimeout(wireSections, 400); });
})();


/* ============================================================
   INNAYA 2026 — INVISIBLE SECTION RESCUE (added 2026-10-21)
   /pages/shipping-policy rendered as a blank white page: the
   PageFly section carried a white background while its text
   was white, so the copy was there but unreadable. Rather
   than patch one section, detect light sections whose own
   text fails contrast against them and drop them onto the
   dark shell. Sections that are light WITH dark text are
   left exactly as they are.
   ============================================================ */
;(function () {
  'use strict';

  function parseRGB(str) {
    var m = String(str).match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(parseFloat);
    if (p.length > 3 && p[3] < 0.5) return null;
    return { r: p[0], g: p[1], b: p[2] };
  }
  function lum(c) {
    var a = [c.r, c.g, c.b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  function ratio(a, b) {
    var l1 = lum(a), l2 = lum(b);
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
  }

  var TEXT_SEL = '[data-pf-type="Paragraph3"],[data-pf-type="Heading2"],' +
                 '[data-pf-type="Text"],[data-pf-type="Heading"],p,h1,h2,h3';

  function rescue() {
    document.querySelectorAll('[data-pf-type="Section"]').forEach(function (s) {
      if (s.dataset.inxRescue) return;

      var bg = parseRGB(getComputedStyle(s).backgroundColor);
      if (!bg) return;
      if (lum(bg) < 0.7) return;              // already a dark section

      var worst = 21, checked = 0;
      var nodes = s.querySelectorAll(TEXT_SEL);
      for (var i = 0; i < nodes.length && checked < 6; i++) {
        var el = nodes[i];
        if (!(el.textContent || '').trim()) continue;
        var fg = parseRGB(getComputedStyle(el).color);
        if (!fg) continue;
        checked++;
        var r = ratio(fg, bg);
        if (r < worst) worst = r;
      }
      if (!checked) return;

      s.dataset.inxRescue = '1';
      if (worst < 2.5) s.classList.add('inx-rescue-dark');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rescue);
  } else { rescue(); }
  window.addEventListener('load', function () {
    rescue();
    setTimeout(rescue, 600);
  });
})();


/* ============================================================
   INNAYA 2026 — BLOG BEHAVIOUR (added 2026-10-21)
   Reading progress on articles, read-time badges on cards,
   and a staggered reveal for the listing grid.
   ============================================================ */
;(function () {
  'use strict';

  var WPM = 225;

  function readTime(words) {
    return Math.max(1, Math.round(words / WPM)) + ' MIN READ';
  }

  function wireProgress() {
    var body = document.querySelector('.article-template__content');
    if (!body || document.querySelector('.inx-progress')) return;

    var bar = document.createElement('div');
    bar.className = 'inx-progress';
    document.body.appendChild(bar);

    var update = function () {
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight;
      if (total <= 0) { bar.style.width = '0%'; return; }
      var done = Math.min(Math.max(-r.top, 0), total);
      bar.style.width = (done / total * 100).toFixed(2) + '%';
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* Read time beside the date */
    var meta = document.querySelector('.article-template > header .circle-divider')
            || document.querySelector('.article-template > header');
    if (meta && !meta.querySelector('.inx-readtime')) {
      var words = (body.textContent || '').trim().split(/\s+/).length;
      var span = document.createElement('span');
      span.className = 'inx-readtime';
      span.textContent = readTime(words);
      meta.appendChild(span);
    }
  }

  function wireCards() {
    var cards = document.querySelectorAll('.blog-articles__article');
    if (!cards.length) return;

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
        'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('inx-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

      cards.forEach(function (c, i) {
        if (c.dataset.inxBlog) return;
        c.dataset.inxBlog = '1';
        var r = c.getBoundingClientRect();
        if (r.height < 20) return;
        c.classList.add('inx-reveal');
        c.style.transitionDelay = Math.min((i % 6) * 70, 420) + 'ms';
        if (r.top < window.innerHeight * 0.95) c.classList.add('inx-in');
        else io.observe(c);
      });
    }

  }

  function run() {
    try { wireProgress(); } catch (e) {}
    try { wireCards(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
  window.addEventListener('load', function () { setTimeout(run, 300); });
})();


/* ============================================================
   INNAYA 2026 — LIGHT CALLOUT RESCUE (added 2026-10-21)
   Product descriptions carry callout boxes with an inline light
   grey background baked into the copy. On the dark shell those
   read as white slabs. Tag any light-backed box inside a product
   description so the stylesheet can darken it.
   ============================================================ */
;(function () {
  'use strict';

  var SCOPES = '.innaya-product-description, .product__description, .rte';

  function isLight(el) {
    var m = String(getComputedStyle(el).backgroundColor)
      .match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!m) return false;
    if (m[4] !== undefined && parseFloat(m[4]) < 0.5) return false;
    var r = +m[1], g = +m[2], b = +m[3];
    return (r + g + b) / 3 > 170;
  }

  function rescue() {
    document.querySelectorAll(SCOPES).forEach(function (scope) {
      scope.querySelectorAll('*').forEach(function (el) {
        if (el.dataset.inxCallout) return;
        var r = el.getBoundingClientRect();
        if (r.width < 80 || r.height < 24) return;
        if (!isLight(el)) return;
        el.dataset.inxCallout = '1';
        el.classList.add('inx-callout-dark');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rescue);
  } else { rescue(); }
  window.addEventListener('load', function () {
    rescue();
    setTimeout(rescue, 700);
  });
})();
